import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';

import CONSTANTS from '@constants';
import { environment } from '@environments/environment';
import { CompanyService } from '@app/shared/services/company.service';

@Component({
  selector: 'app-legal-terms-footer',
  templateUrl: './legal-terms-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LegalTermsFooterComponent implements OnInit {
  @HostBinding('class') class = 'legal-terms-footer';

  imprint: string;
  privacyPolicy: string;
  terms: string;

  constructor(private companyManager: CompanyService) {}

  ngOnInit(): void {
    const domain = this.companyManager.domain(environment.API_BASE);
    const subdomain = this.companyManager.subdomain;

    if (subdomain) {
      const legalTermsUrl = `https://${subdomain}.${domain}/legal-terms`;
      this.terms = `${legalTermsUrl}/terms-of-use`;
      this.privacyPolicy = `${legalTermsUrl}/privacy-policy`;
      this.imprint = `${legalTermsUrl}/imprint`;
    } else {
      this.terms = CONSTANTS.WEB_LINKS.TERMS_SERVICE;
      this.privacyPolicy = CONSTANTS.WEB_LINKS.PRIVACY_POLICY;
      this.imprint = CONSTANTS.WEB_LINKS.IMPRINT;
    }
  }
}
